//@ts-nocheck

'use client'

import React, { useContext, useState } from 'react'
import { motion, AnimatePresence } from 'motion/react'
import { Swiper, SwiperSlide } from 'swiper/react'
import { FreeMode, Mousewheel } from 'swiper/modules'
import normalizeBanner from '../../../models/organisms/Banner'
import Banner from '../Banner/Banner.component'
import * as S from './Tabs.styles'
import Button from '../../atoms/Button/Button.component'
import { SectionThemeContext } from '../../../contexts/SectionTheme.context'
import { SpacerBase } from '../../atoms/GridSystem'

interface Tab {
  id: string
  tabTitle: string
  [key: string]: any
}

interface TabsProps {
  sectionId: string
  colorScheme: string
  type: 'InteractiveTabsBanner'
  tabs: Tab[]
}

interface ComponentDispatcher {
  [key: string]: {
    type: string
    normalizer: (data: any) => any
    component: React.ComponentType<any>
  }
}

const Tabs = ({ sectionId, type, tabs }: TabsProps) => {
  const [selectedTab, setSelectedTab] = useState(0)
  const { selectedColorScheme } = useContext(SectionThemeContext)
  const colorScheme = selectedColorScheme

  const swiperConfig = {
    slidesPerView: 'auto',
    spaceBetween: 16,
    freeMode: {
      enabled: true,
      sticky: false,
      momentumBounce: false,
      momentumVelocityRatio: 0.5,
    },
    mousewheel: {
      enabled: true,
      forceToAxis: true,
    },
  }

  const handleTabChange = (index: number): void => {
    setSelectedTab(index)
  }

  const renderTabContent = () => {
    const dispatcher: ComponentDispatcher = {
      InteractiveTabsBanner: {
        type: 'BannerImage',
        normalizer: normalizeBanner,
        component: Banner,
      },
    }

    const Component = dispatcher[type]

    const formattedData = Component?.component
      ? Component.normalizer(tabs[selectedTab])
      : null

    return Component?.component ? (
        <Component.component
          {...formattedData}
          as="div"
          sectionId={`InteractiveTabsBanner-Banner-${tabs[selectedTab].id}`}
          type={Component.type}
          colorScheme={colorScheme}
          tabItem
        />
    ) : null
  }

  return (
    <S.Tabs as="section" id={sectionId}>
      <S.TabsButtons colorScheme={colorScheme}>
        {/* <S.TabsBorder colorScheme={colorScheme}> */}
          <Swiper modules={[FreeMode, Mousewheel]} {...swiperConfig}>
            {tabs.map(({ id, tabTitle }, index) => {
              return (
                <SwiperSlide key={id}>
                  <Button
                    label={tabTitle}
                    className="tab-button"
                    aria-current={selectedTab === index}
                    handleClick={() => handleTabChange(index)}
                    onKeyDown={(ev: React.KeyboardEvent) =>
                      (ev.key === 'Enter' || ev.key === ' ') &&
                      handleTabChange(index)
                    }
                    variant={'primary'}
                  />
                </SwiperSlide>
              )
            })}
          </Swiper>
        {/* </S.TabsBorder> */}
      </S.TabsButtons>
      <SpacerBase xs={4} />
      <AnimatePresence mode={'wait'}> 
        <motion.div
          initial={{ y: 10, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: -10, opacity: 0 }}
          transition={{ duration: 0.2 }}
          key={selectedTab}
        >
          {renderTabContent()}
        </motion.div>
      </AnimatePresence>
    </S.Tabs>
  )
}

export default Tabs
